export default function Show({ visible = true, children }){
    return visible ? children : <></>
}